<template>
  <v-container fluid>
    <page-header>
      <template slot="topRightSlot">
        <v-btn depressed elevation="0" class="ml-2 mb-4" color="primary" type="button" :to="{ name: 'CreateBlog' }">{{
          $t('add')
        }}</v-btn>
      </template>
    </page-header>

    <datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :itemTotal="tableTotal"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      actionViewRouteLink="BlogDetail"
      disableToolbar
      @options-update="getList()"
    >
      <template v-slot:[`item.data_status`]="{ item }">
        <span :class="{ 'success--text': item.data_status === 'active' }">{{ $t(`blogStatusOptions.${item.data_status}`) }}</span>
      </template>
    </datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
export default {
  name: 'BlogList',
  components: {
    Datatable,
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],
    tableTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
    tableHeaders: [
      { value: 'post_date', text: vm.$t('createDate'), width: 130 },
      { value: 'title', text: vm.$t('heading') },
      { value: 'data_status', text: vm.$t('status'), align: 'end' },
      { value: 'actionView', text: '', align: 'end' },
    ],
  }),
  methods: {
    async getList(regenUrl = true) {
      if (regenUrl) {
        this.regenerateURL()
      }

      this.tableLoading = true
      try {
        const payload = {
          filter_page: this.tableFilter.page - 1,
          filter_limit: this.tableFilter.limit,
        }
        const { total, data } = await this.$Fetcher.GetBlogs(payload)
        this.tableTotal = total
        this.tableData = data.map(item => {
          return {
            id: item.id,
            post_date: item.post_date,
            title: `${item.title_zh}\n${item.title_en}`,
            data_status: item.status,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },

    getQuery() {
      const query = this.$route.query
      if (Object.keys(query).length > 0) {
        if (this.$validate.DataValid(query.p) && this.$validate.regexNumber(query.p)) {
          this.tableFilter.page = parseInt(query.p)
        }

        if (this.$validate.DataValid(query.l) && this.$validate.regexNumber(query.l)) {
          this.tableFilter.limit = parseInt(query.l)
        }
      }
    },
    regenerateURL() {
      const query = this.$route.query
      let q = {
        p: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        l: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, query)
      if (newQuery) {
        this.$router.replace({ query: newQuery })
      }
    },
  },

  async mounted() {
    this.getQuery()
    this.getList(false)
  },
}
</script>
